import React from 'react'
import { isNullOrEmpty } from './index'
import { isResourceComplete } from './resources'
import { questHasContentWarnings } from './contentwarnings'
import UserName from '../components/mini/UserName'

export function isBasicInformationComplete(quest) {
  return !(
    isNullOrEmpty(quest.name) ||
    isNullOrEmpty(quest.description) ||
    isNullOrEmpty(quest.author) ||
    isNullOrEmpty(quest.driving_question) ||
    isNullOrEmpty(quest.type.id)
  )
}

export function areActivitiesComplete(activities) {
  var activitiesIncomplete = false

  if (activities.length > 0) {
    if (
      activities.some(function (activity) {
        return !isActivityComplete(activity)
      })
    ) {
      activitiesIncomplete = true
    }
  } else {
    activitiesIncomplete = true
  }

  return !activitiesIncomplete
}

export function isActivityComplete(activity) {
  let incomplete = false
  if (
    isNullOrEmpty(activity.name) ||
    isNullOrEmpty(activity.description) ||
    isNullOrEmpty(activity.goals) ||
    (Boolean(activity.work_product) && !activity.artifact_type) ||
    (Boolean(activity.resources) &&
      activity.resources.length > 0 &&
      activity.resources.some(r => isResourceComplete(r) === false))
  ) {
    incomplete = true
  }
  return !incomplete
}

export function areImagesComplete(quest) {
  return !isNullOrEmpty(quest.icon_image_url)
}

export function isOtherInformationComplete(quest) {
  return !isNullOrEmpty(quest.tags)
}

export function getCommentResourceType(comment) {
  return comment.section === 'activities' ? 'Activity' : 'Quest'
}

export function findQuestMentorNote(notes) {
  return notes.find(function (note) {
    return note.resource_type === 'Quest'
  })
}

export function findActivity(activities, activityId) {
  const activityIndex = activities.findIndex(function (activity) {
    return activity.id === activityId
  })

  return activities[activityIndex]
}

export function getQuestEditors(quest) {
  const editors = quest.editors.filter(function (editor) {
    return quest.author_ids.indexOf(editor.id) === -1
  })
  return editors
}

export function checkQuestSection(section) {
  if (
    [
      'basicinformation',
      'topicsandstandards',
      'activities',
      'questreview',
      'otherinformation',
      'images',
      'questhistory',
      'skills'
    ].indexOf(section) > -1
  ) {
    return section
  } else {
    return 'basicinformation'
  }
}

/* istanbul ignore next */
export function setActiveMenuItem(activityId) {
  document.querySelectorAll('.quest-menu li').forEach(function (li) {
    li.classList.remove('active')
  })
  const _el = document.getElementById(activityId)
  if (_el && !_el.classList.contains('active')) {
    _el.classList.add('active')
  }
}

export function basicInfoHasJustForMentors(quest, questMentorNote) {
  return (
    !isNullOrEmpty(questMentorNote) ||
    (quest.inline_mentor_notes && quest.inline_mentor_notes.length > 0) ||
    !isNullOrEmpty(quest.mentor_note) ||
    questHasContentWarnings(quest)
  )
}

export function hideQuestComments(section, activityId) {
  return (section === 'activities' && !activityId) || section === 'questhistory'
}

export const getAuthors = ({ authors, questId }) => {
  return (
    <React.Fragment>
      {'By '}
      {authors.map((author, i) => {
        const moreAuthors = authors.length > i + 1
        return (
          <React.Fragment>
            <UserName
              activeCertifications={author.active_certifications}
              userId={`quest-${questId}-author-${author.id}`}
            >
              {author.name}
            </UserName>
            {moreAuthors ? ', ' : ''}
          </React.Fragment>
        )
      })}
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/utils/quest.js